export const AdminUserInlineListSkeleton = ({ count = 3 }) => (
  <div className="admin-user-list">
    {Array.from({ length: count }).map((_, index) => (
      <article
        className="admin-user-card admin-user-card--skeleton admin-skeleton"
        key={index}
        aria-hidden="true"
      >
        <span className="skeleton title" />
        <span className="skeleton text" />
      </article>
    ))}
  </div>
);
